import { Navigate, Route, Routes } from 'react-router';
import { Checkout } from './pages/checkout';
import { NotFound } from './pages/course-not-found';
import { Details } from './pages/details';
import { Registration } from './pages/registration';
import { Catalog } from '.';

export const CoursesRoutes = () => {
  return (
    <Routes>
      <Route index element={<Catalog />} />
      <Route path=":id" element={<Details />} />
      <Route path=":id/inscricao" element={<Registration />} />
      <Route path=":id/checkout/:offerId" element={<Checkout />} />
      <Route path="curso-nao-encontrado" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/cursos" replace />} />
    </Routes>
  );
};
